import { Record } from 'immutable'
import { DemographicValue, IDemographicValue } from './DemographicValue'
import {
  IRaceEthnicityBreakdown,
  RaceEthnicityBreakdown,
} from './RaceEthnicityBreakdown'

export interface IDemographics {
  readonly lastUpdated: number
  readonly lastCensusPopulation: IDemographicValue
  readonly latestPopulation: IDemographicValue
  readonly populationGrowth: IDemographicValue
  readonly avgHouseholdIncome: IDemographicValue
  readonly medianAge: IDemographicValue
  readonly raceEthnicityBreakdown?: IRaceEthnicityBreakdown
}

const DemographicsRecord = Record({
  avgHouseholdIncome: new DemographicValue(),
  lastCensusPopulation: new DemographicValue(),
  lastUpdated: 0,
  latestPopulation: new DemographicValue(),
  medianAge: new DemographicValue(),
  populationGrowth: new DemographicValue(),
  raceEthnicityBreakdown: undefined,
})

export class Demographics extends DemographicsRecord implements IDemographics {
  public static fromJS(initialState?: Partial<IDemographics>) {
    if (!initialState) {
      return new Demographics()
    }

    const {
      avgHouseholdIncome,
      lastCensusPopulation,
      latestPopulation,
      medianAge,
      populationGrowth,
      raceEthnicityBreakdown,
      ...rest
    } = initialState

    return new Demographics({
      avgHouseholdIncome: DemographicValue.fromJS(avgHouseholdIncome),
      lastCensusPopulation: DemographicValue.fromJS(lastCensusPopulation),
      latestPopulation: DemographicValue.fromJS(latestPopulation),
      medianAge: DemographicValue.fromJS(medianAge),
      populationGrowth: DemographicValue.fromJS(populationGrowth),
      raceEthnicityBreakdown: raceEthnicityBreakdown
        ? RaceEthnicityBreakdown.fromJS(raceEthnicityBreakdown)
        : undefined,
      ...rest,
    })
  }

  public readonly lastUpdated: number
  public readonly lastCensusPopulation: DemographicValue
  public readonly latestPopulation: DemographicValue
  public readonly populationGrowth: DemographicValue
  public readonly avgHouseholdIncome: DemographicValue
  public readonly medianAge: DemographicValue
  public readonly raceEthnicityBreakdown?: RaceEthnicityBreakdown

  constructor(initialState?: Partial<Demographics>) {
    initialState ? super(initialState) : super()
  }
}
